var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VGridCell',{staticClass:"schedule-cell",class:_vm.className},[_c('b-link',{staticClass:"text-white stretched-link",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{class:_vm.icon})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }